<template>
  <div class="resource_subject_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="toAddPage('')">新增年级图谱</el-button>
    </div>
    <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="subject_box" v-if="dataList && dataList.length">
        <div class="resource_item" :style="`background: url(${item.imgUrl ? item.imgUrl : 'https://cdnfile-10043692.file.myqcloud.com/admin/images/resource_manage/bg'+ (index%4 + 1) +'.png'}) center center /cover no-repeat;`"
             :title="item.name" @click="toSubjectIndex(item.id)" :key="item.id" v-for="(item, index) in dataList">
          <div class="center_text">{{item.name}}</div>
          <i class="el-icon-edit" @click.stop="toAddPage(item.id)"></i>
          <i class="el-icon-delete" @click.stop="deleteGradeAtlas(item.id)"></i>
        </div>
      </div>
      <div class="no_stu_msg" v-else>
        <img src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
             alt="">
        <div>暂无年级图谱</div>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import {getGradeAtlasDetailListByAtlasId, deleteGradeAtlas} from '@/api/resourceMap'

  export default {
    name: "resourceSubjectIndex",
    data() {
      return {
        atlasId: this.$route.query.subjectId,
        atlasName: this.$route.query.atlasName,
        dataList: []
      }
    },
    mixins: [windowResize],
    created() {
      this.getGradeAtlasDetailListByAtlasId()
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      toAddPage(id) {
        if (id) {
          this.$router.push({path: 'resourceSubjectEdit', query: {atlasId: this.atlasId, id: id}});
        } else {
          this.$router.push({path: 'resourceSubjectAdd', query: {atlasId: this.atlasId}});
        }
      },
      toSubjectIndex(atlasId) {
        sessionStorage.setItem('atlasId', atlasId);
        this.$router.push({path: 'resourceCourse', query: {atlasName: this.atlasName}})
      },
      getGradeAtlasDetailListByAtlasId() {
        getGradeAtlasDetailListByAtlasId({atlasId: this.atlasId}).then(data => {
          this.dataList = data;
        })
      },
      deleteGradeAtlas(id) {
        this.$confirm("确认要删除该年级图谱吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteGradeAtlas({gradeAtlasId: id}).then(data => {
            this.$message.success("删除成功");
            this.getGradeAtlasDetailListByAtlasId();
          });
        }).catch(() => {
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_subject_wrap {
    padding: 12px;
    .header{
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .resource_subject_box{
      @include scrollBar;
      .subject_box{
        @include clearfix;
        padding: 10px 0;

        .resource_item{
          float: left;
          position: relative;
          width: 176px;
          height: 260px;
          margin-top: 20px;
          margin-right: 15px;
          margin-left: 10px;
          overflow: hidden;
          cursor: pointer;
          transition: all .2s linear;
          background: #ededed;
          border-radius: 5px;
          .center_text {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            background: #ccc;
            background: rgba(0,0,0,.3);
          }

          i{
            position: absolute;
            top: 10px;
            right: 40px;
            color: #409eff;
            font-weight: bold;
            display: none;
          }
          .el-icon-delete{
            right: 10px;
            color: #f56c6c;
          }

          &:hover {
            box-shadow: 5px 5px 10px rgba(0, 0, 0, .05), -5px 0 10px rgba(0, 0, 0, .05);
            transform: translate3d(0, -4px, 0);
            i{
              display: block;
            }
          }
        }
      }
      .no_stu_msg {
        text-align: center;
        font-size: 15px;
        color: #999;
        overflow: hidden;

        img {
          display: block;
          margin: 30px auto 0;
        }

        div {
          height: 20px;
          line-height: 20px;
          margin-top: -40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceSubjectIndex.vue